import { Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { appService } from '../../../../app/_services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../../../app/_services/common.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-chat-profiles',
  templateUrl: './chat-profiles.component.html',
  styleUrls: ['./chat-profiles.component.scss']
})
export class ChatProfilesComponent implements OnInit {

  @Input() OrderId: any;
  @Input() OrderNo: any;
  @Input() ProfileData: any;
  @Input() TransactionType: any;
  @Input() tabTitle: any;
  isDropdownOpen: boolean = false;
  Profiles: any;
  CompanyId: any;
  userId: any;
  TenantId: any;
  CustomerLogoPath: any;
  Username: any;
  Email: any;
  Phone: any;
  Transporters: any;
  Drivers: any;
  Type: any;
  @ViewChild('ChatModal') ChatModal: TemplateRef<any>;
  modalRef: NgbModalRef | null = null;
  ChatObj: any = {};
  isCustomerImageError = false;//add by burhan - 24-Jan-2026
  Distance: number = 0; //added by BURHAN - 4-June-2026
  ActualTime: string = '0D 0H'; //added by BURHAN - 4-June-2026


  constructor(
    private _appService: appService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private cookieService: CookieService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.tabTitle = 'Details'
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['OrderId']) {
      this.OrderId = changes['OrderId'].currentValue
      if (this.OrderId) {
        this.getProfiles(this.OrderId, this.TransactionType, this.tabTitle)
      }
    }
    if (changes['tabTitle']) {
      this.tabTitle = changes['tabTitle'].currentValue
      if (this.tabTitle) {
        this.getProfiles(this.OrderId, this.TransactionType, this.tabTitle)
      }
    }
  }

  getProfiles(Id, Type, tabTitle) {
    this._appService.GetByTwoId("OrdersByVehicle", "getProfiles", Id, Type).subscribe(
      (response) => {
        console.log('Console Testing Testing Testing...:', response);
        if (response.Table) {
          this.Profiles = response.Table;
          this.CustomerLogoPath = this.Profiles[0].CustomerLogoPath ? environment.apiUrl + this.Profiles[0].CustomerLogoPath : null;
        }
        this.Transporters = [];  // Store Transporters separately
        this.Drivers = [];       // Store Drivers separately

        // Deduplicate Transporter and Driver using simple objects
        const transporterMap = {};
        const driverMap = {};
        //added by BURHAN - 4-June-2026
        this.Distance = 0; // reset
        this.ActualTime = '0D 0H';
        //end by BURHAN

        if (response.Table1 && response.Table1.length > 0) {

          this.Distance = response.Table1[0].Distance || 0;
          this.ActualTime = response.Table1[0].ActualTime || '0D 0H';
          
          for (let i = 0; i < response.Table1.length; i++) {
            const curr = response.Table1[i];

            // Add Transporter if not already added
            if (curr.TransporterId && !transporterMap[curr.TransporterId]) {
              transporterMap[curr.TransporterId] = true;
              this.Transporters.push({
                TransporterId: curr.TransporterId,
                TransporterName: curr.TransporterName,
                TransporterLogoPath: curr.TransporterLogoPath
                  ? environment.apiUrl + curr.TransporterLogoPath
                  : null
              });
            }

            // Add Driver if not already added
            if (curr.DriverId && !driverMap[curr.DriverId]) {
              driverMap[curr.DriverId] = true;
              this.Drivers.push({
                DriverId: curr.DriverId,
                DriverName: curr.DriverName,
                DriverImage: curr.DriverImage
                  ? environment.apiUrl + curr.DriverImage
                  : null,
                DriverMobileNo: curr.DriverMobileNo
              });
            }
          }
        }
      },
      (err) => {

      }
    );
  }

  //comment by burhan - 24-Jan-2026
  // getInitials(name: string): string {
  //   const nameParts = name.split(' ');
  //   return nameParts.map(part => part.charAt(0).toUpperCase()).join('');
  // }
  
  getInitials(name: string): string {
    if (!name || !name.trim()) return '';

    return name
      .replace(/[^a-zA-Z ]/g, ' ') // D-Mart → D Mart
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  }

  isImageFile(path: string): boolean {
    if (!path) return false;
    return /\.(png|jpg|jpeg|gif|webp)$/i.test(path);
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
  }

  onCustomerImageError() {
    this.isCustomerImageError = true;
  }


  //end by burhan - 24-Jan-2026

  // toggleDropdown() {
  //   this.isDropdownOpen = !this.isDropdownOpen;
  // }

  // toggleDropdown(data, type): void {
  //   console.log('dropdown', data, type)
  //   if(type == 'Customer'){
  //     this.isDropdownOpen = false;
  //     this.Type = 'Customer'
  //     this.Username = data.CustomerName;
  //     this.Email = data.CustomerEmail;
  //     this.Phone = data.CustomerPhone;
  //     this.isDropdownOpen = !this.isDropdownOpen;
  //   } else if(type == 'PickUpContactPerson'){
  //     this.isDropdownOpen = false;
  //     this.Type = 'PickUpContactPerson'
  //     this.Username = data.PickUpContactPerson;
  //     this.Email = data.PickUpContactEmail;
  //     this.Phone = data.PickUpContactNumber;
  //     this.isDropdownOpen = !this.isDropdownOpen;
  //   } else if(type == 'DeliveryContactPerson'){
  //     this.isDropdownOpen = false;
  //     this.Type = 'DeliveryContactPerson'
  //     this.Username = data.DeliveryContactPerson;
  //     this.Email = data.DeliveryContactEmail;
  //     this.Phone = data.DeliveryContactNumber;
  //     this.isDropdownOpen = !this.isDropdownOpen;
  //   } else if(type == 'Transporter'){
  //     this.isDropdownOpen = false;
  //     this.Type = 'Transporter'
  //     this.Username = data.TransporterName;
  //     this.Email = null;
  //     this.Phone = null;
  //     this.isDropdownOpen = !this.isDropdownOpen;
  //   } else if(type == 'Driver'){
  //     this.isDropdownOpen = false;
  //     this.Type = 'Driver'
  //     this.Username = data.DriverName;
  //     this.Email = null;
  //     this.Phone = data.DriverMobileNo;
  //     this.isDropdownOpen = !this.isDropdownOpen;
  //   } 
  // }

  toggleDropdown(data, type): void {
    // If dropdown is already open and the same type is clicked again, close it
    if (this.isDropdownOpen && this.Type === type) {
      this.isDropdownOpen = false;
      return;
    }

    // Otherwise, open and set new data
    this.Type = type;
    if (type === 'Customer') {
      this.Username = data.CustomerName;
      this.Email = data.CustomerEmail;
      this.Phone = data.CustomerPhone;
      this.ChatObj.Username = data.CustomerName;
      this.ChatObj.Email = data.CustomerEmail;
    } else if (type === 'AccountManager') {
      this.Username = data.SalesPersonName;
      this.Email = data.SalesPersonEmail;
      this.Phone = data.SalesPersonPhone;
    } else if (type === 'PickUpContactPerson') {
      this.Username = data.PickUpContactPerson;
      this.Email = data.PickUpContactEmail;
      this.Phone = data.PickUpContactNumber;
      this.ChatObj.Username = data.PickUpContactPerson;
      this.ChatObj.Email = data.PickUpContactEmail;
    } else if (type === 'DeliveryContactPerson') {
      this.Username = data.DeliveryContactPerson;
      this.Email = data.DeliveryContactEmail;
      this.Phone = data.DeliveryContactNumber;
      this.ChatObj.Username = data.DeliveryContactPerson;
      this.ChatObj.Email = data.DeliveryContactEmail;
    } else if (type === 'Transporter') {
      this.Username = data.TransporterName;
      this.Email = null;
      this.Phone = null;
      this.ChatObj.Username = data.TransporterName;
      this.ChatObj.Email = null;
    } else if (type === 'Driver') {
      this.Username = data.DriverName;
      this.Email = null;
      this.Phone = data.DriverMobileNo;
      this.ChatObj.Username = data.DriverName;
      this.ChatObj.Email = null;
      // this.isDropdownOpen = !this.isDropdownOpen;
    }
    this.isDropdownOpen = true;
  }

  OpenChat() {
    this.modalRef = this.modalService.open(this.ChatModal, { centered: true, size: "sm" });
    // this.ChatObj = {};

  }
  WhatsApp(Phone) {
    console.log("Phone:",Phone)
    const msg = `Hello, your order ${this.OrderNo} has received`;
    const url = `https://api.whatsapp.com/send?phone=${this.Phone}&text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");   
  }

}
